<template>
    <div>
        <el-tabs v-model="query.search_status" @tab-click="search">
            <el-tab-pane label="待使用" name="0"></el-tab-pane>
            <el-tab-pane label="已使用" name="1"></el-tab-pane>
            <el-tab-pane label="已失效" name="2"></el-tab-pane>
        </el-tabs>
        <ListPage
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            @search="handleSearch"
            @reset="resetQuery"
        >
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="用户名称/优惠券编号" clearable @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="领取日期" prop="date">
                    <el-date-picker
                        v-model="query.date"
                        type="daterange"
                        align="left"
                        unlink-panels
                        range-separator="-"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                    >
                    </el-date-picker>
                </el-form-item>
            </template>
            <template slot="columns">
                <el-table-column label="优惠券编号" align="center" prop="code" />
                <el-table-column label="用户名称" align="center" prop="nick_name" />
                <el-table-column label="领取时间" align="center" prop="create_time" />
                <el-table-column label="使用状态" align="center">
                    <template slot-scope="{ row }"> {{ ["待使用", "已使用", "已失效"][row.status] }} </template>
                </el-table-column>
                <el-table-column v-if="query.search_status == 0" label="操作" align="center" width="100">
                    <template slot-scope="{ row }">
                        <el-button size="mini" type="text" @click="handleUse(row)"> 使用 </el-button>
                    </template>
                </el-table-column>
                <el-table-column v-if="query.search_status == 1" label="使用时间" align="center" prop="create_time" />
                <el-table-column v-if="query.search_status == 2" label="失效时间" align="center" prop="validity_end_time" />
            </template>
        </ListPage>
        <UseVue ref="use" @update="search"></UseVue>
    </div>
</template>

<script>
import UseVue from "./use.vue";
import { userlist } from "@/api/coupon/list";
import listMixin from "@/mixins/list";
import { startDate, endDate } from "@/pages/config";
export default {
    components: { UseVue },
    data() {
        return {
            list: userlist,
            // 查询参数
            query: {
                search_status: "0",
                search_keyword: "",
                date: [],
            },
            cuuid: null,
        };
    },
    mixins: [listMixin],
    mounted() {
        this.cuuid = this.$route.query.cuuid;
        this.search();
    },
    methods: {
        search() {
            const params = {
                ...this.query,
                cuuid: this.cuuid,
                search_start_time: this.query.date && this.query.date[0] ? startDate(0, this.query.date[0]) : null,
                search_end_time: this.query.date && this.query.date[1] ? endDate(0, this.query.date[1]) : null,
            };
            delete params.date;
            this._search(params);
        },
        handleAdd() {
            this.$router.push({ path: "/coupon/list/form" });
        },
        handleDetail(row) {
            this.$router.push({ path: "/coupon/list/detail", query: { cuuid: row.cuuid } });
        },
        handleEdit(row) {
            this.$router.push({ path: "/coupon/list/form", query: { cuuid: row.cuuid } });
        },
        handleUse(row) {
            this.$refs.use.open(row);
        },
    },
};
</script>

<style></style>
